import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Field, FormikErrors, FormikValues } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import {
  proceedToNextFormStep,
  goBack,
} from "../../../actions/diversityFormActions";
import RadioButton from "../../shared/publicForms/RadioButton";
import TextField from "../../shared/publicForms/TextField";
import {
  StepWrapper,
  Title,
  RadioButtonGroupWrapper,
  RadioButtonGroup,
  BackButton,
  ButtonsWrapper,
  Button,
  DisabledButton,
} from "../styles/diversity-form-styles";

export interface IReligionProps {
  values: {
    religion?: null | string;
  };
  errors: FormikErrors<FormikValues>;
  setFieldValue: (
    field: string,
    value: unknown,
    shouldValidate: boolean
  ) => void;
  proceedToNextFormStepAction: typeof proceedToNextFormStep;
  goBackAction: typeof goBack;
}

export const Religion: FunctionComponent<IReligionProps> = ({
  values,
  errors,
  proceedToNextFormStepAction,
  goBackAction,
  setFieldValue,
}) => {
  const options = [
    null,
    "Buddhist",
    "Christian",
    "Hindu",
    "Jewish",
    "Muslim",
    "Sikh",
    "No religion or belief",
    "Prefer not to say",
  ];

  return (
    <StepWrapper data-test-id="religion-step" formStep>
      <Title data-test-id="title">Which religion do you practice?</Title>
      <RadioButtonGroupWrapper
        role="group"
        aria-labelledby="religion-radio-group"
      >
        <RadioButtonGroup width={220}>
          <Field
            name="religion"
            type="radio"
            aria-label="Buddhist"
            label="Buddhist"
            value="Buddhist"
            as={RadioButton}
          />
          <Field
            name="religion"
            type="radio"
            aria-label="Christian"
            label="Christian"
            value="Christian"
            as={RadioButton}
          />
          <Field
            name="religion"
            type="radio"
            aria-label="Hindu"
            label="Hindu"
            value="Hindu"
            as={RadioButton}
          />
          <Field
            name="religion"
            type="radio"
            aria-label="Jewish"
            label="Jewish"
            value="Jewish"
            as={RadioButton}
          />
          <Field
            name="religion"
            type="radio"
            aria-label="Muslim"
            label="Muslim"
            value="Muslim"
            as={RadioButton}
          />
        </RadioButtonGroup>
        <RadioButtonGroup width={220}>
          <Field
            name="religion"
            type="radio"
            aria-label="Sikh"
            label="Sikh"
            value="Sikh"
            as={RadioButton}
          />
          <Field
            name="religion"
            type="radio"
            aria-label="No religion or belief"
            label="No religion or belief"
            value="No religion or belief"
            as={RadioButton}
          />
          <Field
            name="religion"
            type="radio"
            aria-label="Other"
            label="Other"
            value="Other"
            onChange={() => setFieldValue("religion", "", true)}
            checked={!options.includes(values.religion)}
            as={RadioButton}
          />
          {!options.includes(values.religion) && (
            <Field
              name="religion"
              type="text"
              aria-label={values.religion}
              placeholder="Please specify"
              as={TextField}
            />
          )}
          <Field
            name="religion"
            type="radio"
            aria-label="Prefer not to say"
            label="Prefer not to say"
            value="Prefer not to say"
            as={RadioButton}
          />
        </RadioButtonGroup>
      </RadioButtonGroupWrapper>
      <ButtonsWrapper>
        <BackButton type="button" onClick={goBackAction}>
          <FontAwesomeIcon icon={faChevronLeft} />
          back
        </BackButton>
        {values.religion && !errors.religion ? (
          <Button
            type="button"
            onClick={proceedToNextFormStepAction}
            data-test-id="next-button"
          >
            Next
          </Button>
        ) : (
          <DisabledButton type="button">Next</DisabledButton>
        )}
      </ButtonsWrapper>
    </StepWrapper>
  );
};

Religion.propTypes = {
  values: PropTypes.shape({
    religion: PropTypes.string,
  }).isRequired,
  errors: PropTypes.shape({
    religion: PropTypes.string,
  }).isRequired,
  proceedToNextFormStepAction: PropTypes.func.isRequired,
  goBackAction: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export default connect(null, {
  proceedToNextFormStepAction: proceedToNextFormStep,
  goBackAction: goBack,
})(Religion);
